// deepcode ignore HardcodedNonCryptoSecret - key name
export const SCROLL_RESTORE_KEY = 'wtr_scroll_restore';
